(function () {
  if (window.vtInfo) return;
  window.vtInfo = true;

  function zet(info, open) {
    info.toggleAttribute('data-open', open);
    var knop = info.querySelector('button');
    if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-vt-info] > button');
    document.querySelectorAll('[data-vt-info][data-open]').forEach(function (info) {
      if (!info.contains(e.target)) zet(info, false);
    });
    if (knop) {
      var info = knop.parentElement;
      zet(info, !info.hasAttribute('data-open'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var info = e.target.closest && e.target.closest('[data-vt-info][data-open]');
    if (!info) return;
    zet(info, false);
    info.querySelector('button').focus();
  });
})();
